var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.1011 24.924L62.001 0.824062C61.4738 0.29625 60.7582 0 60.0124 0H19.3436C13.6401 0 9 4.64025 9 10.344V85.6564C9 91.3598 13.6401 96 19.3436 96H76.5814C82.2849 96 86.925 91.3598 86.925 85.6564V26.9124C86.9248 26.1666 86.6284 25.4512 86.1011 24.924Z",
    fill: "#EDECF2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M85.9014 24.9239L61.8013 0.823968C60.9969 0.0194052 59.7874 -0.221157 58.7363 0.214218C57.6853 0.649593 57 1.67503 57 2.81241V19.3812C57 25.085 61.6401 29.7248 67.3436 29.7248H83.9126C85.05 29.7248 86.0758 29.0397 86.511 27.9886C86.9464 26.9377 86.7058 25.7281 85.9014 24.9239Z",
    fill: "#A39CC6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.8c1139f7.svg";
export { ForwardRef as ReactComponent };